
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources04On as ObiSources04OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-04-on.js';
 
 
 

 
 export const ObiSources04On = createComponent({
   react: React,
   tagName: 'obi-sources-04-on',
   elementClass: ObiSources04OnElement,
   events: {
     
   }
  });
 
 